module.exports = __webpack_public_path__ + "img/icon_lottery_card.c7365992.png";